/*
* Created on Mar 25, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import page_not_found_png from '../static/img/illustration/illustration-page-not-found.png'
import {useNavigate} from "../hook/NavigateHook";

const Component404 = ({setStandalone, setShowFooter}) => {
    const {t} = useTranslation();
    const {goHome} = useNavigate()

    useEffect(()=>{
        setStandalone(true)
        setShowFooter(true)

        return () => {
            setStandalone(false);
            setShowFooter(false)
        }
    }, []);

    return (
        <div className="content-section content-not-found">
            <div className="infographic">
                <div className="illus-wrap">
                    <img src={page_not_found_png} />
                </div>
            </div>
            <div className="info-content">
                <div className="info-content-head">
                    {t("@We're sorry.@")}
                    <br/>
                    {t("@The page you are looking for cannot be found.@")}
                </div>
                <div className="info-content-body">
                    <div className="text-wrap">{t("@The page you are looking for cannot be found.@")}</div>
                    <button className="q-btn q-btn-primary q-btn-round-corner !mt-24" onClick={goHome}>{t("@Return to Organization Center@")}</button>
                </div>
            </div>
        </div>
    );
};

export default Component404;